"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChartScatter: function() {
        return ChartScatter;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ChartScatter = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 2C3.55228 2 4 2.44772 4 3V19C4 19.5523 4.44772 20 5 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2ZM19.5 6.5C20.0523 6.5 20.5 6.94772 20.5 7.5V7.51C20.5 8.06228 20.0523 8.51 19.5 8.51C18.9477 8.51 18.5 8.06228 18.5 7.51V7.5C18.5 6.94772 18.9477 6.5 19.5 6.5ZM9.5 7.5C10.0523 7.5 10.5 7.94772 10.5 8.5V8.51C10.5 9.06228 10.0523 9.51 9.5 9.51C8.94772 9.51 8.5 9.06228 8.5 8.51V8.5C8.5 7.94772 8.94772 7.5 9.5 7.5ZM14.5 11.5C15.0523 11.5 15.5 11.9477 15.5 12.5V12.51C15.5 13.0623 15.0523 13.51 14.5 13.51C13.9477 13.51 13.5 13.0623 13.5 12.51V12.5C13.5 11.9477 13.9477 11.5 14.5 11.5ZM8.5 14.5C9.05228 14.5 9.5 14.9477 9.5 15.5V15.51C9.5 16.0623 9.05228 16.51 8.5 16.51C7.94772 16.51 7.5 16.0623 7.5 15.51V15.5C7.5 14.9477 7.94772 14.5 8.5 14.5ZM18.5 14.5C19.0523 14.5 19.5 14.9477 19.5 15.5V15.51C19.5 16.0623 19.0523 16.51 18.5 16.51C17.9477 16.51 17.5 16.0623 17.5 15.51V15.5C17.5 14.9477 17.9477 14.5 18.5 14.5Z",
        fill: "currentColor"
    })
}), "ChartScatter");
const _default = ChartScatter;
